import { render, staticRenderFns } from "./StudentCleaning.vue?vue&type=template&id=37d7b98a&scoped=true&"
import script from "./StudentCleaning.vue?vue&type=script&lang=ts&"
export * from "./StudentCleaning.vue?vue&type=script&lang=ts&"
import style0 from "./StudentCleaning.vue?vue&type=style&index=0&id=37d7b98a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d7b98a",
  null
  
)

export default component.exports